import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link, useRouteMatch } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import Container from "@mui/material/Container";
import UserSubjectFavoritePicturesSelector from "@/react/Webshop/Components/UserSubjectFavoritePicturesSelector";
import { usePictureSet } from "@/react/Webshop/Mobile/hooks/usePictureSet";
import BottomBar from "@/react/Webshop/Mobile/Components/BottomBar";
import { generatePath } from "react-router";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
const MyAccountFavoritePictures = () => {
    const { params } = useRouteMatch();
    const routes = useMobileRoutes();
    const { notFound, pictureSet, isLoaded } = usePictureSet(params.pictureSetUuid);
    if (!isLoaded || !pictureSet) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Loading..")));
    }
    if (!pictureSet.qualifyForSelectOwnFavorites) {
        return (React.createElement(MobilePage, null,
            React.createElement(AppBar, null),
            React.createElement(PageHeader, null,
                React.createElement(Trans, null, "Select your favorites")),
            React.createElement(Container, null,
                React.createElement("p", null,
                    pictureSet.subject.name,
                    React.createElement(Trans, null, "Selecting your own favorites is not available for this subject")))));
    }
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null,
            React.createElement(Trans, null, "Select your favorites")),
        React.createElement(Container, null,
            React.createElement(UserSubjectFavoritePicturesSelector, { pictureSet: pictureSet })),
        React.createElement(BottomBar, null,
            React.createElement(Container, null,
                React.createElement(Box, { display: "flex", justifyContent: "flex-end", py: 1 },
                    React.createElement(Button, { color: "primary", variant: "contained", component: Link, to: generatePath(routes["myaccount.picturesets.pictureset"].path, { uuid: pictureSet.uuid }) },
                        React.createElement(Trans, null, "Go back")))))));
};
export default MyAccountFavoritePictures;
